import "./App.css";
import { Fragment, React, useEffect, useState } from "react";
import { RouterProvider, createBrowserRouter, useLocation } from "react-router-dom";

import Home from "./pages/home/Home";
import Product from "./pages/product/Product";
import Cart from "./pages/cart/Cart";
import Register from "./pages/auth/Register";
import Login from "./pages/auth/Login";
import Dashboard from "./pages/dashboard/Dashboard";
import Root, { rootLoader } from "./routes/Root";
import RootAuth from "./routes/RootAuth";
import RootUser from "./routes/RootUser";
import ProtectedRoute from "./routes/ProtectedRoute";
import { AuthProvider, UserProvider } from "./context/contextAPI";
import UserProfil from "./pages/mon-profil/UserProfil";
import { ToastContainer } from "react-toastify";
import Parrainage from "./pages/parrainage/Parrainage";
import RegisterRef from "./pages/auth/RegisterRef";
import Shop from "./pages/shop/Shop";
import Test from "./components/Test";
import Achats from "./pages/achat/Achats";
import Facture from "./Facture";
import Transaction from "./pages/transaction/Transaction";
import UserList from "./pages/user_list/UserList";
import Subscribe from "./pages/subscribe/Subscribe";

const RegisterRouter = () => {
  const location = useLocation();

  const params = new URLSearchParams(location.search);
  const referralCode = params.get('ref');

  if (referralCode) {
    return <RegisterRef />;
  }
  return <Register />;
};

const router = createBrowserRouter([
  {
    path: "/",
    element: <Root />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "produits",
        element: <Product />,
      },
      {
        path: "panier",
        element: <Cart />,
      },
    ],
  },
  {
    path: "/auth",
    element: <RootAuth />,
    children: [
      {
        path: "inscription",
        element: <RegisterRouter />,
      },
      {
        path: "connexion",
        element: <Login />,
      },
      {
        path: "facture",
        element: <Facture />,
      },
    ],
  },
  {
    path: "/utilisateur",
    element: <RootUser />,
    children: [
      {
        path: "achats",
        element: <Achats />,
      },
      {
        path: "parrainage",
        element: <ProtectedRoute element={<Parrainage />} />,
      },
      {
        path: "transactions",
        element: <ProtectedRoute element={<Transaction />} />,
      },
      {
        path: "profil",
        element: <ProtectedRoute element={<UserProfil />} />,
      },
      {
        path: "subscribe",
        element: <ProtectedRoute element={<Subscribe />} />,
      },
      {
        path: "liste_utilisateur",
        element: <ProtectedRoute element={<UserList />} />,
      },
      {
        path: "boutique",
        element: <Shop />,
      },
    ],
  },
]);

function App() {
  return (
    <>
      <AuthProvider>
        <UserProvider>
          <div className="app">
            <ToastContainer />
            <RouterProvider router={router} />
          </div>
        </UserProvider>
      </AuthProvider>
    </>
  );
}

export default App;
